import React from 'react';
import { equiv } from '../../../utils/utils';
import { CaseProps } from './Case';

interface SwitchProps {
  test: CaseProps['value'];
}

const Switch: React.FC<SwitchProps> = ({ test, children }) => {
  let match: React.ReactElement | null = null;

  React.Children.forEach(children, (child) => {
    if (
      match ||
      child === null ||
      typeof child !== 'object' ||
      !('props' in child)
    ) {
      return;
    }
    if (equiv(child?.props?.value, test)) {
      match = child;
    }
  });
  return match;
};

export default Switch;
